export const OrderServiceSymbols = {
    OrderService: Symbol.for("OrderService"),
    OrderProvider: Symbol.for("OrderProvider")
}